import React from 'react';
import lockIcon from '../../../assets/FinalStage/lock.png';
import classes from './LockedButton.module.css';

const LockedButton = ({ text, className }) => {
  return (
    <button type="button" className={classes.locked}>
      <img src={lockIcon} alt="" className={classes.lockedIcon} aria-hidden />
      <span className={classes.lockedText}>{text}</span>
    </button >
  );
};

export default LockedButton;
